import { Component, OnInit } from '@angular/core';
import { Log } from 'ng2-logger';
import { AdminService } from '../../_services/admin.service';
import {DrilldownResponse, ModuleFamily} from '../../_models/drilldown';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { ACLFeature } from '../../_models/acl-feature';

import 'rxjs/add/operator/mergeMap';


const log = Log.create('EditFamilies');

@Component({
  templateUrl: 'edit.component.html',
  styleUrls: ['edit.less']
})

export class FamiliesEditComponent implements OnInit {

  family: ModuleFamily = new ModuleFamily('');
  parentId: number;
  parentParams: any;
  is4level: boolean;
  path: string;
  id: any;
  parent: any;
  iCanMaintenanceMode: boolean = false;
  iCanArchive: boolean = true;
  iCanViewArchive: boolean = true;
  loader: boolean = false;

  constructor(private admin: AdminService,
              private route: ActivatedRoute,
              private router: Router,
              private toast: ToastsManager) {}

  ngOnInit() {
    log.d('ngOnInit');
    //
    // log.d('parentparams', this.route.snapshot.parent.params);
    this.admin.canI(ACLFeature.MAINTENANCE_MODE_ADMIN).subscribe((iCan: boolean) => {
      this.iCanMaintenanceMode = iCan;
    });

    this.admin.canI(ACLFeature.VIEW_ARCHIVE_IN_ADMIN).subscribe((iCan: boolean) => {
      this.iCanViewArchive = iCan;
    });

    this.admin.canI(ACLFeature.ARCHIVE).subscribe((iCan: boolean) => {
      this.iCanArchive = iCan;
    });

    this.route.params.subscribe((params: any) => {
      log.d('ActivatedRoute', this.route);
      log.d('Router', this.router);
      log.d('router params', params);

      this.parentParams = this.route.snapshot.parent.params;
      log.d('parentparams', this.parentParams);

      this.path = (this.parentParams['type'] === 'modules') ? '/drilldown/modules' : '/drilldown/drivers';

      if (this.parentParams['parentId']) {
        this.family.parentId = this.parentParams['parentId'] == null || this.parentParams['parentId'] === 'null' ? null : this.parentParams['parentId'];
        if (this.family.parentId != null) {
          this.admin.getFamily(this.parentParams['type'], this.family.parentId).subscribe((data) => {
            this.parent = data.data;
          });
        }
      } else {
        // no parent id, so root.
        this.family.parentId = null;
      }

      // only do the api call is there is an id in the route params
      if (params.id) {
        this.id = params.id;

        this.admin.getFamilies(this.route.snapshot.parent.params['type'], params['id']).subscribe((data) => {
          this.family = data;
          this.setIsTunableWhite();
          this.is4level = this.family.parent.parent !== undefined && this.family.parent.parent.parent === null;
          log.d('family', this.family);
        });
      }
    });
  }

  private setIsTunableWhite () {
    if (this.family.metadata !== undefined) {
      try {
        const metadata = JSON.parse(this.family.metadata) || {};
        this.family.isTunableWhite = metadata.tunable_white;
      } catch (exceptionVar) {
        console.log(exceptionVar);
      }
    }
  }

  private setMetadata() {
    let metadata = {};
    if (this.family.metadata !== undefined) {
      try {
        metadata = JSON.parse(this.family.metadata) || {};
      } catch (exceptionVar) {
        console.log(exceptionVar);
        return;
      }
    }
    metadata['tunable_white'] = this.family.isTunableWhite;
    this.family.metadata = JSON.stringify(metadata);
  }

  public onSaveFamily() {
    this.loader = true;
    log.d('onSaveFamily');
    this.setMetadata();

    // the familiy has an ID, so it already exists. Update the existing one.
    if (this.id) {
      const family = JSON.stringify(this.family);
      log.d('sending this to newfamily:', family);
      this.admin.updateFamilies(this.parentParams['type'], this.family.id, family).subscribe((data) => {
        this.loader = false;
        log.d('response from newFamily call', data);
        this.toast.success(`Changes have been saved.`);
        this.navigateBack();
      });
    } else {
      // the familiy doesn't have an id yet, so submit it as a new family.
      this.family.parent = this.parent;
      const family = JSON.stringify([this.family]);
      log.d('sending this to newfamily:', family);
      this.admin.newFamily(this.parentParams['type'], family).subscribe((data) => {
        this.loader = false;
        log.d('response from newFamily call', data);
        this.toast.success(`New family was created successfully`);
        this.navigateBack();
      });
    }
  }

  private navigateBack() {
    const options: any = {};

    if (this.parentParams['parentId']) {
      options.parentId = this.parentParams['parentId'];
    }
    if (this.parentParams['showArchived']) {
      options.showArchived = this.parentParams['showArchived'];
    }
    options.refresh = Date.now();

    this.router.navigate([this.path, options], {relativeTo: this.route} );
  }

  public onCancelFamily() {
    log.d('onCancelFamily');
    this.navigateBack();
  }
}



// WEBPACK FOOTER //
// ./src/app/families/edit/edit.component.ts